import React, { useEffect } from 'react';
// eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
import { graphql, useFragment } from 'react-relay';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import type { async_softwareReleasesLaunchCard_LaunchCard$key } from '@atlassian/jira-relay/src/__generated__/async_softwareReleasesLaunchCard_LaunchCard.graphql';
import { lazyAfterPaint, useLazyPhase } from '@atlassian/react-loosely-lazy';
import { BaseWrapper, MainContentWrapper } from './index.tsx';
import {
	LoadingWrapper,
	StatusLoading,
	LatestDeploymentLoading,
	TwoColumnFieldWrapper,
	FieldLoadingWrapper,
	FieldLabelLoading,
	FieldContentLoading,
} from './styled.tsx';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const LazyLaunchCard = lazyAfterPaint(
	() =>
		import(/* webpackChunkName: "async-version-detail-launch-card" */ './index').then(
			(module) => module.LaunchCard,
		),
	{ ssr: false },
);

type Props = {
	jiraVersion: async_softwareReleasesLaunchCard_LaunchCard$key;
};

export const Loading = (): React.JSX.Element => (
	<LoadingWrapper>
		<BaseWrapper>
			<MainContentWrapper>
				<StatusLoading />
				<TwoColumnFieldWrapper height={63}>
					<FieldLoadingWrapper>
						<FieldLabelLoading />
						<FieldContentLoading />
					</FieldLoadingWrapper>
					<FieldLoadingWrapper>
						<FieldLabelLoading />
						<FieldContentLoading />
					</FieldLoadingWrapper>
				</TwoColumnFieldWrapper>
				<TwoColumnFieldWrapper height={52}>
					<FieldLoadingWrapper>
						<FieldLabelLoading />
						<FieldContentLoading />
					</FieldLoadingWrapper>
					<FieldLoadingWrapper>
						<FieldLabelLoading />
						<FieldContentLoading />
					</FieldLoadingWrapper>
				</TwoColumnFieldWrapper>
			</MainContentWrapper>
		</BaseWrapper>
		<LatestDeploymentLoading />
	</LoadingWrapper>
);

export const LaunchCard = ({ jiraVersion }: Props): React.JSX.Element => {
	const { startNextPhase } = useLazyPhase();
	useEffect(() => {
		startNextPhase();
	}, [startNextPhase]);

	const version = useFragment(
		// eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
		graphql`
			fragment async_softwareReleasesLaunchCard_LaunchCard on JiraVersion {
				...ui_softwareReleasesLaunchCard_LaunchCard
			}
		`,
		jiraVersion,
	);

	return (
		<Placeholder name="version-detail-launch-card" fallback={<Loading />}>
			<LazyLaunchCard jiraVersion={version} />
		</Placeholder>
	);
};
